<template>
  <div>
    <PageAllow controller="AllianceBusinesses" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="mx-3 mt-4">
        <v-card-title class="mx-3">
          {{
            $t("AlliancesShops.shopList", [alliance_name, $consts.shopName()])
          }}
        </v-card-title>
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title class="mx-3">
                {{ $t("AlliancesShops.backUp", [$consts.shopName()]) }}
                <v-spacer />
                <v-btn color="primary" dense small @click="addAllShops()">
                  <v-icon small class="pe-1">fa-angle-double-right</v-icon>
                  {{ $t("AlliancesShops.choose") }}
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <!-- 搜索行 -->
              <v-row dense class="mx-5">
                <v-col cols="12" sm="12" md="6">
                  <v-row dense align="center" class="pa-1">
                    <SearcherKeyword
                      ref="keyword_one"
                      v-model="unselectOptions.shop_keyword"
                      @text="shopKeywordOneText($event)"
                      :label="$t('AlliancesShops.shop', [$consts.shopName()])"
                    />
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-row dense align="center" class="pa-1">
                    <v-menu v-model="menuOne" open-on-hover open-on-focus>
                      <template v-slot:activator="{ on, attrs }">
                        <v-autocomplete
                          color="primary"
                          hide-no-data
                          v-model="districtSelectedOne"
                          clearable
                          chips
                          multiple
                          deletable-chips
                          small-chips
                          :items="districtSelectedOne"
                          :loading="districtsLoading"
                          :search-input.sync="districtsSearchOne"
                          item-text="name"
                          item-value="id"
                          :label="$t('District.title')"
                          return-object
                          v-bind="attrs"
                          v-on="on"
                        >
                          <template v-slot:append>
                            <v-icon
                              style="height: 24px; width: 24px"
                              :color="menuOne ? 'primary' : ''"
                              @click.stop="menuOne = !menuOne"
                            >
                              {{ menuOne ? "fa-caret-up" : "fa-caret-down" }}
                            </v-icon>
                          </template>
                        </v-autocomplete>
                      </template>
                      <div style="max-height: 304px">
                        <v-sheet>
                          <v-treeview
                            v-model="districtSelectedOne"
                            :items="districts"
                            :search="districtsSearchOne"
                            :filter="districtsFilter"
                            selection-type="independent"
                            item-text="name"
                            item-key="id"
                            item-children="districts"
                            open-all
                            selectable
                            selected-color="primary"
                            hoverable
                            return-object
                          />
                        </v-sheet>
                      </div>
                    </v-menu>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 表格 -->
              <v-data-table
                :headers="unselectedHeaders"
                :items="unselectedItems"
                :loading="loadingOne"
                :options.sync="unselectOptions"
                :page.sync="pagingOne.page"
                :server-items-length="pagingOne.count"
                multi-sort
                class="elevation-0 px-6"
                fixed-header
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:header.action="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.action="{ item }">
                  <div class="d-flex mt-n2 mb-n3">
                    <v-btn
                      color="primary"
                      dense
                      small
                      @click="
                        currentItem = item;
                        addShop();
                      "
                    >
                      <v-icon small class="pe-1">fa-plus</v-icon>
                      <!-- {{ $t("Shop.Fields.choose") }} -->
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title class="mx-3">
                {{ $t("AlliancesShops.selected", [$consts.shopName()]) }}
                <v-spacer />
                <v-btn color="error" dense small @click="removeAllShops()">
                  <v-icon small class="pe-1">fa-angle-double-left</v-icon>

                  {{ $t("AlliancesShops.remove") }}
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <!-- 搜索行 -->
              <v-row dense class="mx-5">
                <v-col cols="12" sm="12" md="6">
                  <v-row dense align="center" class="pa-1">
                    <SearcherKeyword
                      ref="keyword_two"
                      v-model="selectOptions.shop_keyword"
                      @text="shopKeywordTwoText($event)"
                      :label="$t('AlliancesShops.shop', [$consts.shopName()])"
                    />
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-row dense align="center" class="pa-1">
                    <v-menu v-model="menuTwo" open-on-hover open-on-focus>
                      <template v-slot:activator="{ on, attrs }">
                        <v-autocomplete
                          color="primary"
                          hide-no-data
                          v-model="districtSelectedTwo"
                          clearable
                          chips
                          multiple
                          deletable-chips
                          small-chips
                          :items="districtSelectedTwo"
                          :loading="districtsLoading"
                          :search-input.sync="districtsSearchTwo"
                          item-text="name"
                          item-value="id"
                          :label="$t('District.title')"
                          return-object
                          v-bind="attrs"
                          v-on="on"
                        >
                          <template v-slot:append>
                            <v-icon
                              style="height: 24px; width: 24px"
                              :color="menuTwo ? 'primary' : ''"
                              @click.stop="menuTwo = !menuTwo"
                            >
                              {{ menuTwo ? "fa-caret-up" : "fa-caret-down" }}
                            </v-icon>
                          </template>
                        </v-autocomplete>
                      </template>
                      <div style="max-height: 304px">
                        <v-sheet>
                          <v-treeview
                            v-model="districtSelectedTwo"
                            :items="districts"
                            :search="districtsSearchTwo"
                            :filter="districtsFilter"
                            selection-type="independent"
                            item-text="name"
                            item-key="id"
                            item-children="districts"
                            open-all
                            selectable
                            selected-color="primary"
                            hoverable
                            return-object
                          />
                        </v-sheet>
                      </div>
                    </v-menu>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 表格 -->
              <v-data-table
                :headers="selectedHeaders"
                :items="selectedItems"
                :options.sync="selectOptions"
                :loading="loadingTwo"
                :page.sync="pagingTwo.page"
                :server-items-length="pagingTwo.count"
                multi-sort
                class="elevation-0 px-6"
                fixed-header
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:header.action="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.action="{ item }">
                  <div class="d-flex mt-n2 mb-n3">
                    <v-btn
                      color="error"
                      dense
                      small
                      @click="
                        currentItem = item;
                        removeShop();
                      "
                    >
                      <v-icon small class="pe-1">fa-minus</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-sheet>
  </div>
</template>
<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import AlliancesShops from "@/api/alliance_business_shops";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Alliances from "@/api/alliance_businesses";
import Districts from "@/api/districts";

const defaultSelectOptions = {
  shop_keyword: "",
  district_ids: [],
};
const defaultUnSelectOptions = {
  shop_keyword: "",
  district_ids: [],
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    // SearcherDistricts,
  },
  data: () => ({
    alliance_business_id: "",
    selectOptions: JSON.parse(JSON.stringify(defaultSelectOptions)),
    unselectOptions: JSON.parse(JSON.stringify(defaultUnSelectOptions)),
    districtSelectedOne: [], //未选分组筛选
    districtSelectedTwo: [], //已选分组筛选
    selectedItems: [],
    unselectedItems: [],
    currentItem: {},
    alliance_name: "",
    menuOne: false,
    menuTwo: false,
    districts: [],
    districtsSearchOne: "",
    districtsSearchTwo: "",
    districtsLoading: false,
    pagingOne: {},
    pagingTwo: {},
    loadingOne: false,
    loadingTwo: false,
  }),
  mounted() {
    this.fetchUnSelectShops();
    this.fetchSelectShops();
    this.getAlliancesFromAPI();
    this.getDistrictsFromAPI();
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopManagement", [this.$consts.shopName()]),
          disabled: false,
          href: "/shops",
        },
        {
          text: i18n.t("Nav.alliances", [this.$consts.allianceName()]),
          disabled: true,
          href: "/alliances",
        },
      ];
    },
    unselectedHeaders() {
      return [
        {
          text: i18n.t("AlliancesShops.Fields.shop", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("AlliancesShops.Fields.district"),
          align: "start",
          sortable: false,
          value: "district.name",
        },
        {
          text: i18n.t("AlliancesShops.Fields.action"),
          align: "start",
          sortable: false,
          value: "action",
        },
      ];
    },
    selectedHeaders() {
      return [
        {
          text: i18n.t("AlliancesShops.Fields.shop", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop.shop_name",
        },
        {
          text: i18n.t("AlliancesShops.Fields.district"),
          align: "start",
          sortable: false,
          value: "shop.district.name",
        },
        {
          text: i18n.t("AlliancesShops.Fields.action"),
          align: "start",
          sortable: false,
          value: "action",
        },
      ];
    },
    districtsFilter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.alliance_business_id = this.$route.params.id;
      },
    },
    unselectOptions: {
      deep: true,
      handler() {
        this.fetchUnSelectShops();
      },
    },
    selectOptions: {
      deep: true,
      handler() {
        this.fetchSelectShops();
      },
    },
    districtSelectedOne: {
      handler() {
        this.unselectOptions.district_ids = this.districtSelectedOne
          ? this.districtSelectedOne.map((e) => {
              return e.id;
            })
          : [];
      },
    },
    districtSelectedTwo: {
      handler() {
        this.selectOptions.district_ids = this.districtSelectedTwo
          ? this.districtSelectedTwo.map((e) => {
              return e.id;
            })
          : [];
      },
    },
    ...mapState(["loading", "stickTableCols"]),
  },
  methods: {
    getDistrictsFromAPI() {
      this.districtsLoading = true;
      Districts.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.districts = response.data.districts;
            }
            this.districtsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.districtsLoading = false;
          }.bind(this)
        );
    },
    // 获取已选门店列表
    fetchSelectShops() {
      this.loadingTwo = true;
      AlliancesShops.fetchSelectShops(
        this.alliance_business_id,
        this.selectOptions
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.selectedItems = response.data.alliance_business_shops;
            this.pagingTwo = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.selectOptions.page = 1;
          }
          this.loadingTwo = false;
        }.bind(this)
      );
    },
    // 获取未选门店列表
    fetchUnSelectShops() {
      this.loadingOne = true;
      AlliancesShops.fetchUnSelectShops(
        this.alliance_business_id,
        this.unselectOptions
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.unselectedItems = response.data.shops;
            this.pagingOne = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.unselectOptions.page = 1;
          }
          this.loadingOne = false;
        }.bind(this)
      );
    },

    // 绑定单个门店
    addShop() {
      this.$store.dispatch("fullscreenLoading");
      var data = { shop_id: this.currentItem.id };
      AlliancesShops.addShop(this.alliance_business_id, data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.fetchUnSelectShops();
              this.fetchSelectShops();
              this.$store.dispatch("fullscreenLoadingStop");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(this.$store.dispatch("fullscreenLoadingStop"));
    },

    // 绑定所有门店
    addAllShops() {
      this.$store.dispatch("fullscreenLoading");
      AlliancesShops.addAllShops(
        this.alliance_business_id,
        this.unselectOptions
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.fetchUnSelectShops();
              this.fetchSelectShops();
              this.$store.dispatch("fullscreenLoadingStop");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(this.$store.dispatch("fullscreenLoadingStop"));
    },

    // 移除单个门店
    removeShop() {
      this.$store.dispatch("fullscreenLoading");
      var data = { shop_id: this.currentItem.shop_id };
      AlliancesShops.removeShop(this.alliance_business_id, data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.fetchSelectShops();
              this.fetchUnSelectShops();
              this.$store.dispatch("fullscreenLoadingStop");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(this.$store.dispatch("fullscreenLoadingStop"));
    },
    // 移除所有门店
    removeAllShops() {
      this.$store.dispatch("fullscreenLoading");
      AlliancesShops.removeAllShops(
        this.alliance_business_id,
        this.selectOptions
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.fetchSelectShops();
              this.fetchUnSelectShops();
              this.$store.dispatch("fullscreenLoadingStop");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(this.$store.dispatch("fullscreenLoadingStop"));
    },
    getAlliancesFromAPI() {
      Alliances.fetchAll(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            var alliances = response.data.alliance_businesses;
            alliances.forEach((e) => {
              if (this.alliance_business_id == e.id)
                this.alliance_name = e.alliance_business_name;
            });
          }
        }.bind(this)
      );
    },
    shopKeywordOneText(e) {
      this.unselectOptions.shop_keyword = e;
    },
    shopKeywordTwoText(e) {
      this.selectOptions.shop_keyword = e;
    },
  },
};
</script>
